export enum EEntityType {
    PERSONAL = 'PERSONAL',
    CORPORATION = 'CORPORATION',
}